<template>
    <div id="container-card" class="flex pb-special mb-button">
        <div id="delete" @click=" emits('del');" class="rounded-full w-mark-reproductor-desktop mr-4 flex flex-wrap items-center text-red-error-text justify-center p-xxs">
            <font-awesome-icon icon="trash" />
        </div>
        <div id="data" class="flex flex-col justify-around ml-min w-1/2 pr-special">
            <div id="product-name" class="mb-text">
                <span class="font-bloggerM text-secondary-desktop max-md:text-secondary-mobile dark:text-primary-dark-text">
                    {{ data['name'] }}
                </span>
            </div>
            <div id="product-qty" class="flex">
                <div id="minus" @click="minus()" class="rounded-full bg-primary-color-1st w-18 flex flex-wrap items-center justify-center p-xxs dark:bg-secondary-color-1st">
                    <font-awesome-icon icon="minus" class="w-photo-desk h-photo-desk dark:text-primary-dark-text" />
                </div>
                <div id="qty" class="form-input p-0 w-15% flex flex-wrap items-end justify-center text-content-desktop font-monserratM rounded-none mx-text max-md:text-content-mobile dark:text-primary-dark-text">
                    {{ data['qty'] }}
                </div>
                <div id="plus" @click="plus()" class="rounded-full bg-primary-color-1st w-18 flex flex-wrap items-center justify-center p-xxs dark:bg-secondary-color-1st">
                    <font-awesome-icon icon="plus" class="w-photo-desk h-photo-desk dark:text-primary-dark-text" />
                </div>
            </div>
        </div>
        <div id="container-price-total" class="w-1/2 flex flex-wrap items-center justify-between pr-special">
            <span class="text-description text-primary-color-1st font-monserratM max-md:text-content-mobile dark:text-primary-dark-text">
                {{ 'L. ' + data['price'].replace('$', '') }}
            </span>
            <span class="font-bloggerB text-content-title-desktop ml-special max-md:text-content-title-mobile text-primary-text dark:text-primary-dark-text">
                {{ 'L. ' + subtotal }}
            </span>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { defineEmits } from 'vue';
import { shoppingCart } from '@/stores/shoppingCart';

const storeS = shoppingCart();
const props = defineProps([
    'data'
])

const emits = defineEmits([
    'newQty',
    'del'
])

var subtotal = ref(0)

var valuesCalc = ref({
    qty: props.data['qty'],
    price: props.data['price'].replace('$', '')
})

subtotal.value = storeS.calculateSubTotal(valuesCalc.value);

/**
 * Function used to increase the quantity of the product in the shopping cart
 */
const plus = () => {
    if ((valuesCalc.value['qty'] + 1) <= props.data['total']) {
        valuesCalc.value['qty'] += 1;
        subtotal.value = storeS.calculateSubTotal(valuesCalc.value);
        emits('newQty', valuesCalc.value['qty']);
    }
}

/**
 * Function used to decrease the quantity of the product in the shopping cart
 */
const minus = () => {
    if ((valuesCalc.value['qty'] - 1) >= 1) {
        valuesCalc.value['qty'] -= 1;
        subtotal.value = storeS.calculateSubTotal(valuesCalc.value);
        emits('newQty', valuesCalc.value['qty']);
    }
}

</script>